export default __webpack_public_path__ + "static/media/expl_014_EN.ab074a5e.png";